import { render, staticRenderFns } from "./DespesaUpdate.vue?vue&type=template&id=65246009"
import script from "./DespesaUpdate.vue?vue&type=script&lang=js"
export * from "./DespesaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports